module.exports = __webpack_public_path__ + "static/media/altros-name-blue.628d75e4.png";